import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'

const tabs = [
  {
    to: '/defender',
    label: 'Reporting devices',
    match: (pathname) => pathname === '/defender',
  },
  {
    to: '/defender/detections',
    label: 'Detections',
    match: (pathname) => pathname.startsWith('/defender/detections'),
  },
]

export function DefenderNav() {
  const { pathname } = useLocation()

  return (
    <nav className="flex gap-1 border-b border-border">
      {tabs.map((tab) => {
        const active = tab.match(pathname)
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={cn(
              'px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors',
              active
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {tab.label}
          </NavLink>
        )
      })}
    </nav>
  )
}
